<script>
    import _        from 'lodash'
    import * as api from '../../shared/api.js'

    export let buffer = []
    export let filter = {}
    export let domain
    export let error = false

    let working = false
    let cookie
    let email

    function search() {
        filter  = { cookie, email }
        working = true
        error   = false
        api
            .post("/consent/query", { domain: domain.id, cookie, email })
            .then(api.toJsonIf200)
            .then(data => {
                working = false
                buffer = data
            })
            .catch(err => {
                console.log(err)
                buffer  = []
                working = false
                error   = true
            })
    }
</script>

<div class="filter">
    <div style="flex:1"></div>
    <div class="ui input" class:disabled={working}>
        <input  type="text" 
                placeholder="cookie"
                bind:value={cookie}
                on:focus={() => email = null}>
    </div>
    <div class="ui input" class:disabled={working}>
        <input  type="text" 
                placeholder="email"
                bind:value={email}
                on:focus={() => cookie = null}>
    </div>
    <div class="ui input">
        <button 
            class="ui blue button"
            class:disabled={working}
            class:loading={working} 
            on:click={search}>Buscar</button>
    </div>
</div>

<style>
    .filter {
        display: flex;
        flex-direction: row;
        justify-content: flex-end;
    }

    .filter .input {
        margin-left: 1em;
    }
</style>
